import React from 'react';
import cx from 'classnames';

import ReactCookieConsent from 'react-cookie-consent';

import styles from './cookie-consent.module.scss';

const CookieConsent = () => (
  /* TODO: move role to component when it will be supported */
  <div role="banner">
    <ReactCookieConsent
      cookieName="gatsby-gdpr-google-tagmanager"
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      disableStyles
      containerClasses={cx(styles.container, 'react-cookie-consent')}
      contentClasses={styles.content}
      buttonClasses={styles.button}
      buttonWrapperClasses={styles.buttonWrapper}
    >
      This website uses cookies to enhance the user experience
    </ReactCookieConsent>
  </div>
);

export default CookieConsent;
